import { createSelector } from 'reselect';

const selectGlobalDBARegistries = (state: any) => state.globalDBARegistries;


export const selectGlobalDBARegistriesCurrentItem = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.current);

export const selectGlobalDBARegistriesListItems = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectGlobalDBARegistriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalDBARegistriesQueryItems = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.query);

export const selectGlobalDBARegistriesCreatedItem = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.create);

export const selectGlobalDBARegistriesUpdatedItem = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.update);

export const selectGlobalDBARegistriesReadItem = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.read);

export const selectGlobalDBARegistriesDeletedItem = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.delete);

export const selectGlobalDBARegistriesSearchedItems = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.search);

export const selectGlobalDBARegistriesItemsCount = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.count);

export const selectGlobalDBARegistriesItemsFilter = createSelector([selectGlobalDBARegistries], (globalDBARegistries) => globalDBARegistries.filter);